import type { SVGProps } from 'react';

const SvgDoubleArrowRightLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M12 20L20 12L12 4' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4 20L12 12L4 4' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgDoubleArrowRightLt;
